
import { h } from 'preact';
import { parseDate } from 'utils/utils';
import Form from 'components/bolt/forms/form/form';

export default class RegalForm extends Form {
	renderHiddenFields() {
		const date = parseDate(this.props.data.formDate);
		const { selectedTheaterName, movieTitle } = this.props;
		return (
			<div id="hidden-fields">
				<input type="hidden" name="Theatre" value={selectedTheaterName} />
				<input type="hidden" name="Date" value={new Intl.DateTimeFormat('en-US').format(new Date(date))} />
				<input type="hidden" name="Movie" value={movieTitle} />
				<input type="hidden" name="ReferralDetails" value="Powster" />
				<input type="hidden" name="LeadSourceDetails" value="Powster" />
				<input type="hidden" name="EventProductName" value="Meeting & Movie" />
				<input type="hidden" name="Owner" value="32071894-71e7-e911-a83e-000d3a192483" />
				<input type="hidden" name="OwnerIsTeam" value="True" />
				<input type="hidden" name="EventType" value="Business Event" />
			</div>
		);
	}
}